<template>
  <div class="bg-fff user-message">
    <div class="titles-right font-style">我的活动</div>
    <div class="ma-t-20 flex" v-for="(item, index) in dataList" :key="index" @click="toDetail(item.Id)">
      <img :src="item.MainImage" class="img_230 img_cover" />
      <div class="ma-l-10">
        <span class="fon-18 weight500">{{ item.Name }}</span>
        <div class="ma-t-15 fon-14 c-5 t-omit-3 ma-r-20">
          {{ item.Summary }}
        </div>
        <br />
        <div class="flex f-between">
          <span class="ma-r-30 w-50 d-i-b"
                >时间：{{ item.StartTime }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="dataList.length==0" class="pa-t-100">
      <Empty></Empty>
    </div>
    
    <div class="t-center ma-t-20">
      <el-pagination
        @current-change="handleCurrentChange"
        :hide-on-single-page="true"
        :current-page.sync="queryList.pageIndex"
        :page-size="queryList.pageSize"
        layout="prev, pager, next, jumper"
        :total="totals"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { myParticipationActivity } from "../api";
export default {
  name: "myactivity",
  data() {
    return {
      dataList: [],
      tabIndex: 0, //0 =》资讯收藏，1=》方案收藏
      queryList: {
        pageIndex: 1,
        pageSize: 10,
        source: "web",
      },
      totals: 0,
    };
  },
  mounted() {
    this.loadDataList();
  },
  methods: {
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.queryList.pageIndex = e;
      this.loadDataList();
    },
    loadDataList() {
        myParticipationActivity(this.queryList).then((res) => {
          this.dataList = res.data.Data.Data;
          this.totals = res.data.Data.TotalCount;
        });
    },
    //查看详情
    toDetail(id) {
      this.$router.push({
        path: "/Activity",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style  lang="scss" scoped>
.titles-right:before {
  content: "|";
  display: inline-block;
  width: 4px;
  height: 19px;
  background: #234775;
  color: #234775;
  border-radius: 2px;
  margin-right: 8px;
}
.width920px {
  width: 920px;
}
.font-style {
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
}
.tab-active {
  border-bottom: 2px solid #234775;
}

.img_230 {
  width: 230px;
  height: 149px;
}
</style>